import Vue from "vue";
import tipsVue from "./index.vue";
import merge from "@/utils/merge";

const defaults = {};

const tipsConstructor = Vue.extend(tipsVue);
const tips = options => {
    options = merge({}, defaults, options);
    let instance = new tipsConstructor({
        data: options
    });
    instance._vm = instance.$mount();
    instance._el = instance.$el;
    instance._instance = instance;
    document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
    return instance;
};

export default tips;